import { Component, Input, OnInit } from '@angular/core';
import { PQRFatorPonderacaoDto } from '../../dtos';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { TabelaComponent } from '../tabela/tabela.component';
import { NgForOf, NgIf } from '@angular/common';

@Component({
  selector: 'app-dialog-pqr-fator-ponderacao',
  standalone: true,
  imports: [
    MatDialogActions,
    MatDialogContent,
    TabelaComponent,
    NgForOf,
    NgIf,
    MatDialogClose,
    MatDialogTitle,
  ],
  templateUrl: './dialog-pqr-fator-ponderacao.component.html',
  styleUrl: './dialog-pqr-fator-ponderacao.component.scss',
})
export class DialogPqrFatorPonderacaoComponent implements OnInit {
  @Input() dados!: PQRFatorPonderacaoDto[];

  dadosTabela!: PQRFatorPonderacaoDto[];

  ngOnInit(): void {
    this.dadosTabela = this.dados;
  }
}
